import jsPDF from 'jspdf';
import * as XLSX from 'xlsx';

export const exportToPDF = (locations, activityLogs) => {
  const doc = new jsPDF();
  
  doc.setFontSize(20);
  doc.text('Reporte - File Marca One', 20, 20);
  
  doc.setFontSize(10);
  doc.text(`Fecha: ${new Date().toLocaleDateString('es-MX')}`, 20, 30);
  
  doc.setFontSize(12);
  doc.text('Estadisticas Generales', 20, 50);
  
  doc.setFontSize(10);
  doc.text(`Total Ubicaciones: ${locations.length}`, 30, 60);
  doc.text(`Total Archivos: ${locations.length * 5}`, 30, 70);
  doc.text(`Almacenamiento Total: ${locations.length * 500} MB`, 30, 80);
  
  doc.setFontSize(12);
  doc.text('Ubicaciones', 20, 100);
  
  let yPos = 110;
  doc.setFontSize(9);
  doc.text('Ubicacion', 30, yPos);
  doc.text('Descripcion', 80, yPos);
  doc.text('Archivos', 150, yPos);
  
  yPos += 10;
  locations.forEach((loc) => {
    doc.text(loc.name, 30, yPos);
    doc.text(loc.description || '-', 80, yPos);
    doc.text('5/5', 150, yPos);
    yPos += 10;
  });
  
  doc.save(`Reporte-FileMarcaOne-${new Date().toISOString().split('T')[0]}.pdf`);
};

export const exportToExcel = (locations, activityLogs) => {
  const locationData = locations.map((loc) => ({
    'Ubicacion': loc.name,
    'Descripcion': loc.description || '-',
    'Archivos': '5/5',
    'Almacenamiento': '500 MB',
    'Creado': new Date(loc.created_at).toLocaleDateString('es-MX')
  }));
  
  const ws = XLSX.utils.json_to_sheet(locationData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Ubicaciones');
  
  const statsData = [
    { Metrica: 'Total Ubicaciones', Valor: locations.length },
    { Metrica: 'Total Archivos', Valor: locations.length * 5 },
    { Metrica: 'Almacenamiento Total (MB)', Valor: locations.length * 500 },
    { Metrica: 'Fecha del Reporte', Valor: new Date().toLocaleDateString('es-MX') }
  ];
  
  const wsStats = XLSX.utils.json_to_sheet(statsData);
  XLSX.utils.book_append_sheet(wb, wsStats, 'Estadisticas');
  
  XLSX.writeFile(wb, `Reporte-FileMarcaOne-${new Date().toISOString().split('T')[0]}.xlsx`);
};
